export const fields = {
  propertyStatus: {
    type: "customRadio",
    name: "qualification_property_status",
    options: [
      {
        id: "settled",
        value: "quitado",
        label: "quitado",
        ariaLabel: "quitado"
      },
      {
        id: "not_settled",
        value: "financiado",
        label: "financiado",
        ariaLabel: "financiado"
      },
      {
        id: "without_property",
        value: "nao_tenho_imovel",
        label: "não tenho imóvel",
        ariaLabel: "não tenho imóvel"
      }
    ]
  },
  propertyOwner: {
    type: "customRadio",
    name: "qualification_property_owner",
    options: [
      {
        id: "property_owner_yes",
        value: "sim",
        label: "sim",
        ariaLabel: "sim"
      },
      {
        id: "property_owner_no",
        value: "nao",
        label: "não",
        ariaLabel: "não"
      }
    ],
    sendFormat: "bool"
  },
  propertyRegistrationUpdated: {
    type: "customRadio",
    name: "qualification_property_registration_updated",
    options: [
      {
        id: "property_registration_updated_yes",
        value: "sim",
        label: "sim",
        ariaLabel: "sim"
      },
      {
        id: "property_registration_updated_no",
        value: "nao",
        label: "não",
        ariaLabel: "não"
      }
    ],
    sendFormat: "bool"
  }
}
